import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Lock, ShieldCheck, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CountdownDark } from '../components/Countdown';
import { useScreenInit } from '../useScreenInit';
export function Checkout() {
  useScreenInit();
  const [upsell1, setUpsell1] = useState(false);
  const [upsell2, setUpsell2] = useState(false);
  const basePrice = 17;
  const upsell1Price = 5;
  const upsell2Price = 7;
  const total = basePrice + (upsell1 ? upsell1Price : 0) + (upsell2 ? upsell2Price : 0);
  return <div className="min-h-screen bg-slate-50 font-sans pb-20" data-id="element-218">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50" data-id="element-219">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center justify-between" data-id="element-220">
          <Link to="/" className="flex items-center gap-2 text-slate-500 hover:text-slate-800 transition-colors" data-id="element-221">
            <ArrowLeft className="w-5 h-5" data-id="element-222" />
            <span className="font-medium hidden md:inline" data-id="element-223">Volver</span>
          </Link>
          <div className="font-bold text-xl text-slate-800" data-id="element-224">carrito</div>
          <div className="flex items-center gap-2 text-sm font-medium bg-red-50 text-red-600 px-3 py-1.5 rounded-full" data-id="element-225">
            <span className="hidden md:inline" data-id="element-226">Oferta expira en</span>
            <CountdownDark initialMinutes={5} initialSeconds={0} data-id="element-227" />
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 pt-8" data-id="element-228">
        <div className="mb-8" data-id="element-229">
          <h1 className="text-3xl font-bold text-slate-900 mb-2" data-id="element-230">Tu pedido</h1>
          <p className="text-slate-600" data-id="element-231">Revisá tu compra antes de pagar</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 items-start" data-id="element-232">
          {/* Main Content */}
          <div className="md:col-span-2 space-y-6" data-id="element-233">
            {/* Main Product */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200" data-id="element-234">
              <div className="flex gap-4" data-id="element-235">
                <div className="w-20 h-24 bg-gradient-to-br from-blue-600 to-indigo-800 rounded-lg flex items-center justify-center text-3xl shadow-inner flex-shrink-0" data-id="element-236">
                  📖
                </div>
                <div className="flex-1" data-id="element-237">
                  <div className="flex justify-between items-start mb-1" data-id="element-238">
                    <h3 className="font-bold text-lg text-slate-900" data-id="element-239">
                      Ebook principal
                    </h3>
                    <div className="text-right" data-id="element-240">
                      <div className="text-xs text-slate-400 line-through" data-id="element-241">
                        USD 242
                      </div>
                      <div className="font-bold text-lg text-blue-700" data-id="element-242">
                        USD 17
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-slate-500 mb-3" data-id="element-243">
                    Acceso digital inmediato
                  </p>
                  <span className="bg-green-100 text-green-700 text-xs font-bold px-2 py-1 rounded" data-id="element-244">
                    80% OFF
                  </span>
                </div>
              </div>
            </div>

            {/* Upsells */}
            <div data-id="element-245">
              <h3 className="font-bold text-lg text-slate-900 mb-4" data-id="element-246">
                Mejorá tu compra
              </h3>

              <div className="space-y-4" data-id="element-247">
                {/* Upsell 1 */}
                <label className={`block border-2 rounded-2xl p-5 cursor-pointer transition-all ${upsell1 ? 'border-blue-500 bg-blue-50/30' : 'border-slate-200 bg-white hover:border-blue-300'}`} data-id="element-248">
                  <div className="flex gap-4" data-id="element-249">
                    <div className="pt-1" data-id="element-250">
                      <div className={`w-6 h-6 rounded border flex items-center justify-center ${upsell1 ? 'bg-blue-600 border-blue-600' : 'border-slate-300 bg-white'}`} data-id="element-251">
                        {upsell1 && <Check className="w-4 h-4 text-white" data-id="element-252" />}
                      </div>
                      <input type="checkbox" className="hidden" checked={upsell1} onChange={() => setUpsell1(!upsell1)} data-id="element-253" />
                    </div>
                    <div className="flex-1" data-id="element-254">
                      <div className="flex justify-between items-start mb-2" data-id="element-255">
                        <div data-id="element-256">
                          <span className="bg-red-100 text-red-700 text-xs font-bold px-2 py-1 rounded mb-2 inline-block" data-id="element-257">
                            -50%
                          </span>
                          <h4 className="font-bold text-slate-900" data-id="element-258">
                            Estrategia de optimización y escalado
                          </h4>
                        </div>
                        <div className="text-right" data-id="element-259">
                          <div className="text-xs text-slate-400 line-through" data-id="element-260">
                            $10
                          </div>
                          <div className="font-bold text-blue-700" data-id="element-261">$5</div>
                        </div>
                      </div>
                      <p className="text-sm text-slate-600 leading-relaxed" data-id="element-262">
                        Guía para interpretar el rendimiento, ajustar
                        segmentación, aterrizajes y creativos, y escalar
                        presupuesto con método, evitando el típico "subir y
                        rezar".
                      </p>
                    </div>
                  </div>
                </label>

                {/* Upsell 2 */}
                <label className={`block border-2 rounded-2xl p-5 cursor-pointer transition-all ${upsell2 ? 'border-blue-500 bg-blue-50/30' : 'border-slate-200 bg-white hover:border-blue-300'}`} data-id="element-263">
                  <div className="flex gap-4" data-id="element-264">
                    <div className="pt-1" data-id="element-265">
                      <div className={`w-6 h-6 rounded border flex items-center justify-center ${upsell2 ? 'bg-blue-600 border-blue-600' : 'border-slate-300 bg-white'}`} data-id="element-266">
                        {upsell2 && <Check className="w-4 h-4 text-white" data-id="element-267" />}
                      </div>
                      <input type="checkbox" className="hidden" checked={upsell2} onChange={() => setUpsell2(!upsell2)} data-id="element-268" />
                    </div>
                    <div className="flex-1" data-id="element-269">
                      <div className="flex justify-between items-start mb-2" data-id="element-270">
                        <div data-id="element-271">
                          <span className="bg-red-100 text-red-700 text-xs font-bold px-2 py-1 rounded mb-2 inline-block" data-id="element-272">
                            -50%
                          </span>
                          <h4 className="font-bold text-slate-900" data-id="element-273">
                            Investigación de competencia con IA
                          </h4>
                        </div>
                        <div className="text-right" data-id="element-274">
                          <div className="text-xs text-slate-400 line-through" data-id="element-275">
                            $14
                          </div>
                          <div className="font-bold text-blue-700" data-id="element-276">$7</div>
                        </div>
                      </div>
                      <p className="text-sm text-slate-600 leading-relaxed" data-id="element-277">
                        Aprende a traducir el análisis de la competencia
                        (anuncios, reseñas y patrones) en decisiones concretas
                        de tu campaña, diferenciándote con propuestas claras.
                      </p>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>

          {/* Sidebar Summary */}
          <div className="md:col-span-1" data-id="element-278">
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 sticky top-24" data-id="element-279">
              <h3 className="font-bold text-lg text-slate-900 mb-4 border-b border-slate-100 pb-4" data-id="element-280">
                Resumen
              </h3>

              <div className="space-y-3 mb-6 text-sm" data-id="element-281">
                <div className="flex justify-between text-slate-600" data-id="element-282">
                  <span data-id="element-283">Ebook principal</span>
                  <span className="font-medium text-slate-900" data-id="element-284">USD 17</span>
                </div>
                {upsell1 && <div className="flex justify-between text-slate-600" data-id="element-285">
                    <span data-id="element-286">Estrategia optimización</span>
                    <span className="font-medium text-slate-900" data-id="element-287">$5</span>
                  </div>}
                {upsell2 && <div className="flex justify-between text-slate-600" data-id="element-288">
                    <span data-id="element-289">Investigación IA</span>
                    <span className="font-medium text-slate-900" data-id="element-290">$7</span>
                  </div>}
              </div>

              <div className="border-t border-slate-100 pt-4 mb-6" data-id="element-291">
                <div className="flex justify-between items-end" data-id="element-292">
                  <span className="font-bold text-slate-900" data-id="element-293">Total</span>
                  <span className="text-2xl font-black text-blue-700" data-id="element-294">
                    USD {total.toLocaleString('en-US')}
                  </span>
                </div>
              </div>

              <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 rounded-xl shadow-lg shadow-blue-600/20 transition-all flex items-center justify-center gap-2 mb-4" data-id="element-295">
                <Lock className="w-5 h-5" data-id="element-296" /> Continuar compra
              </button>

              <div className="flex items-center justify-center gap-2 text-xs text-slate-500 font-medium" data-id="element-297">
                <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-298" />
                Pago seguro con Stripe
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}